import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import "./StartupProjects.scss";
import {bigProjects} from "../../portfolio";
import {Fade} from "../../components/FadeReveal/FadeReveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  const { t } = useTranslation();
  
  function getTranslatedProjectDesc(projectName, originalDesc) {
    switch(projectName) {
      case "Joblogic": return t('projects.joblogic.desc');
      case "Jalsah": return t('projects.jalsah.desc');
      case "FamilyTime": return t('projects.familytime.desc');
      case "Alfalah": return t('projects.alfalah.desc');
      case "Get An Expert": return t('projects.getexpert.desc');
      case "Quokka": return t('projects.quokka.desc');
      case "Scanner App": return t('projects.scanner.desc');
      case "SKU Scanner": return t('projects.skuscanner.desc');
      case "Community Maker": return t('projects.community.desc');
      case "Pisiﬃk": return t('projects.pisiffik.desc');
      case "My 360 Key": return t('projects.my360key.desc');
      case "Life Sign": return t('projects.lifesign.desc');
      case "Flovso App": return t('projects.flovso.desc');
      default: return originalDesc;
    }
  }
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{t('projects.title')}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {t('projects.subtitle')}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {getTranslatedProjectDesc(project.projectName, project.projectDesc)}
                    </p>
                    {project.techStack && (
                      <p className={isDark ? "dark-mode tech-label" : "tech-label"}>
                        <strong>Tech:</strong> {project.techStack}
                      </p>
                    )}
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <span
                              key={i}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={() => openUrlInNewTab(link.url)}
                            >
                              {link.name === "View Project" ? t('projects.viewProject') : link.name}
                            </span>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
